@if (statistic>=80) {
  <img src="./assets/img/badge-gold-sm.png">
}
@if (statistic>=80) {
  <small>
    <strong>&nbsp;Gold</strong>
  </small>
}
@if (statistic>=70 && statistic<79) {
  <img src="./assets/img/badge-silver-sm.png">
}
@if (statistic>=70 && statistic<79) {
  <small>
    <strong>&nbsp;Silver</strong>
  </small>
}
@if (statistic>=50 && statistic<69) {
  <img src="./assets/img/badge-bronze-sm.png">
}
@if (statistic>=50 && statistic<69) {
  <small>
    <strong>&nbsp;Bronze</strong>
  </small>
}
@if (statistic>0 && statistic<50) {
  <img src="./assets/img/badge-entry-sm.png">
}
@if (statistic>0 && statistic<50) {
  <small>
    <strong>&nbsp;Entry</strong>
  </small>
}

@if (!noDiscussion && totalDisucssionNotEngaged>0) {
  <small> ({{totalDisucssionNotEngaged | i18nPlural: messageMapping}}) </small>
}
@if (noDiscussion && !hasNoDiscussionInModule) {
  <small>{{totalDisucssionNotEngaged}} discussions with no participation</small>
}
@if (hasNoDiscussionInModule) {
  <small>No discussions in this module</small>
}
